import React from "react";
import {
  Box,
  Container,
  Typography,
  Paper,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import SingleCodeEditor from "../../../shared/SingleCodeEditor";

const FeatureFile = ({
  title,
  content,
  handleSaveContent,
  // handleContentChange,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const isTablet = useMediaQuery(theme.breakpoints.down("lg"));

  return (
    <Container
      maxWidth="xl"
      sx={{
        height: "100%",
        py: { xs: 2, md: 3 },
        px: { xs: 1, sm: 2, md: 3 },
      }}
    >
      {/* Header Section */}
      <Box
        sx={{
          mb: { xs: 2, md: 3 },
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          justifyContent: "space-between",
          alignItems: { xs: "flex-start", sm: "center" },
          gap: 2,
        }}
      >
        <Typography
          variant="h4"
          sx={{
            fontSize: { xs: "20px", sm: "24px", md: "28px" },
            fontWeight: 700,
            color: "#1a1a1a",
            fontFamily: "Manrope, sans-serif",
            lineHeight: 1.2,
          }}
        >
          {title}
        </Typography>
      </Box>

      {/* Editor Section */}
      <Paper
        elevation={0}
        sx={{
          borderRadius: "16px",
          overflow: "hidden",
          border: "1px solid #e0e0e0",
          background: "#ffffff",
          transition: "all 0.3s ease-in-out",
          "&:hover": {
            boxShadow: "0 8px 32px rgba(0,0,0,0.08)",
            borderColor: "#d0d0d0",
          },
        }}
      >
        {/* Instructions Header */}
        <Box
          sx={{
            px: { xs: 2, md: 3 },
            py: { xs: 1.5, md: 2 },
            backgroundColor: "#f8fafc",
            borderBottom: "1px solid #e2e8f0",
            display: "flex",
            alignItems: "center",
            gap: 2,
          }}
        >
          <Typography
            sx={{
              fontSize: { xs: "13px", md: "14px" },
              // color: "#64748b",
              fontWeight: 500,
              fontFamily: "Manrope, sans-serif",
            }}
          >
            Click inside the editor to start editing.
          </Typography>
        </Box>

        {/* Code Editor */}
        <Box
          sx={{
            p: { xs: 1, md: 2 },
            backgroundColor: "#ffffff",
          }}
        >
          <SingleCodeEditor
            title="Code Editor"
            initialValue={content}
            language="html"
            height={isMobile ? "400px" : isTablet ? "500px" : "600px"}
            onSave={handleSaveContent}
            // onContentChange={handleContentChange}
            theme="vs-dark"
            allowCopy={true}
            allowReset={true}
            // autoSave={true}
            // autoSaveDelay={3000}
            showSaveNotification={false} // Disable popup for cleaner UX
            sx={{
              borderRadius: "12px",
              border: "none",
              "& .monaco-editor": {
                borderRadius: "12px",
              },
            }}
          />
        </Box>
      </Paper>
    </Container>
  );
};

export default FeatureFile;
